export default __webpack_public_path__ + "static/media/vXrp.74c8140e.svg";